/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PooledLoyaltyAccount } from './PooledLoyaltyAccount';
import {
    PooledLoyaltyAccountFromJSON,
    PooledLoyaltyAccountFromJSONTyped,
    PooledLoyaltyAccountToJSON,
    PooledLoyaltyAccountToJSONTyped,
} from './PooledLoyaltyAccount';

/**
 * Response containing loyalty accounts shared with the requesting user via active family pool relationships. Each entry is wrapped with attribution to the owning peer. Does not include aggregate values (account_total, total_cash_value, points_update_total) — those remain the responsibility of the user's own loyalty endpoint.
 * @export
 * @interface PooledLoyaltyAccountsResponse
 */
export interface PooledLoyaltyAccountsResponse {
    /**
     * Loyalty accounts shared with the user via family pool.
     * @type {Array<PooledLoyaltyAccount>}
     * @memberof PooledLoyaltyAccountsResponse
     */
    pooledAccounts: Array<PooledLoyaltyAccount>;
}

/**
 * Check if a given object implements the PooledLoyaltyAccountsResponse interface.
 */
export function instanceOfPooledLoyaltyAccountsResponse(value: object): value is PooledLoyaltyAccountsResponse {
    if (!('pooledAccounts' in value) || value['pooledAccounts'] === undefined) return false;
    return true;
}

export function PooledLoyaltyAccountsResponseFromJSON(json: any): PooledLoyaltyAccountsResponse {
    return PooledLoyaltyAccountsResponseFromJSONTyped(json, false);
}

export function PooledLoyaltyAccountsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PooledLoyaltyAccountsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'pooledAccounts': ((json['pooled_accounts'] as Array<any>).map(PooledLoyaltyAccountFromJSON)),
    };
}

export function PooledLoyaltyAccountsResponseToJSON(json: any): PooledLoyaltyAccountsResponse {
    return PooledLoyaltyAccountsResponseToJSONTyped(json, false);
}

export function PooledLoyaltyAccountsResponseToJSONTyped(value?: PooledLoyaltyAccountsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pooled_accounts': ((value['pooledAccounts'] as Array<any>).map(PooledLoyaltyAccountToJSON)),
    };
}

